import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["buttonStyles"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { CustomThemeButton } from '@atlaskit/button';
import { useSource } from '@atlassian/mpac-utils';
import React from 'react';
import { curvedStyles, emceeBaseStyles, emceeGhostStyles, forgeButtonStyles, linkOverrideStyles, mpacBaseStyles, mpacGhostStyles } from './Button.styles';
import { jsx as _jsx } from "react/jsx-runtime";
const ourTheme = function ourTheme() {
  let overrideStyles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (currentTheme, themeProps) => {
    const _currentTheme = currentTheme(themeProps),
      {
        buttonStyles
      } = _currentTheme,
      rest = _objectWithoutProperties(_currentTheme, _excluded);
    return _objectSpread({
      buttonStyles: _objectSpread(_objectSpread({}, buttonStyles), overrideStyles)
    }, rest);
  };
};
export function Button(props) {
  const source = useSource();
  const styles = source === 'MPAC' ? mpacBaseStyles : emceeBaseStyles;
  return /*#__PURE__*/_jsx(CustomThemeButton, _objectSpread(_objectSpread({
    theme: ourTheme(styles)
  }, props), {}, {
    children: props.children
  }));
}
export function LinkButton(props) {
  return /*#__PURE__*/_jsx(CustomThemeButton, _objectSpread(_objectSpread({
    theme: ourTheme(linkOverrideStyles)
  }, props), {}, {
    spacing: "none",
    children: props.children
  }));
}
export function GhostButton(props) {
  const source = useSource();
  const styles = source === 'MPAC' ? mpacGhostStyles : emceeGhostStyles;
  const finalStyles = React.useMemo(() => {
    if (!props.isEnabledAdvancedExperimentOnPricingTab) {
      return styles;
    }
    return _objectSpread(_objectSpread({}, styles), {}, {
      borderColor: props.isAdvancedEdition ? "var(--ds-border-accent-blue, #1D7AFC)" : "var(--ds-border-accent-gray, #758195)",
      color: props.isAdvancedEdition ? "var(--ds-chart-blue-bolder, #1D7AFC)" : "var(--ds-chart-gray-bolder, #758195)"
    });
  }, [props.isEnabledAdvancedExperimentOnPricingTab, props.isAdvancedEdition, styles]);
  const themed = React.useMemo(() => ourTheme(finalStyles), [finalStyles]);
  return /*#__PURE__*/_jsx(CustomThemeButton, _objectSpread(_objectSpread({
    theme: themed
  }, props), {}, {
    children: props.children
  }));
}
export function CurvedButton(props) {
  return /*#__PURE__*/_jsx(CustomThemeButton, _objectSpread(_objectSpread({
    theme: ourTheme(curvedStyles)
  }, props), {}, {
    children: props.children
  }));
}
export function ForgeButton(props) {
  return /*#__PURE__*/_jsx(CustomThemeButton, _objectSpread(_objectSpread({
    theme: ourTheme(forgeButtonStyles)
  }, props), {}, {
    children: props.children
  }));
}